module.exports = __webpack_public_path__ + "static/media/manual-verification.08972e30.png";